export default __webpack_public_path__ + "static/media/blush-cold-summer.f2ad3c2b.png";